import React, { useEffect, useState } from "react";
import { TESTIMONIALS } from "@/lib/mockData";
import { Star } from "lucide-react";

const Testimonials = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % TESTIMONIALS.length), 5500);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="max-w-2xl mb-12">
          <p className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-3">
            What our partners say
          </p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-zinc-50"
            data-testid="testimonials-heading"
          >
            Brand teams who'd partner with us again.
          </h2>
        </div>

        <div className="relative overflow-hidden rounded-2xl border border-white/8 bg-gradient-to-br from-blue-500/[0.06] to-transparent p-8 lg:p-12 min-h-[260px]">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={t.name}
              className={`absolute inset-0 p-8 lg:p-12 transition-opacity duration-700 ${
                i === idx ? "opacity-100" : "opacity-0 pointer-events-none"
              }`}
              data-testid={`testimonial-${i}`}
            >
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="h-4 w-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <blockquote className="text-2xl lg:text-3xl font-medium text-zinc-100 tracking-tight leading-snug">
                "{t.quote}"
              </blockquote>
              <div className="mt-8 flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-zinc-800 flex items-center justify-center text-zinc-300 text-sm font-medium">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-medium text-zinc-50">{t.name}</div>
                  <div className="text-xs text-zinc-500">
                    {t.role} · {t.company}
                  </div>
                </div>
                <span className="ml-auto text-[11px] px-2 py-1 rounded-md bg-white/5 border border-white/10 text-zinc-400">
                  {t.tag}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 flex justify-center gap-2">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              aria-label={`Show testimonial ${i + 1}`}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === idx ? "w-8 bg-blue-500" : "w-2 bg-zinc-700"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
